import { Navigate } from 'react-router-dom';
import { Container, Paper, Typography, CircularProgress, Box, Stack, Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { FormProvider } from 'react-hook-form';
import { useCustomerAuth } from '../CustomerAuthContext';
import { useBookingPage } from './booking-page.hooks';
import { BookingHeader } from '../components/booking/booking-header';
import { LoyaltyPointsBadge } from '../components/loyalty-points-badge';
import { BookingCalendarSection } from '../components/booking/booking-calendar-section';
import { BookingReservationSummary } from '../components/booking/booking-reservation-summary';
import { MyVisitsList } from '../components/MyVisitsList';

const BookingPage = () => {
  const { isAuthenticated } = useCustomerAuth();

  const {
    loading,
    servicesData,
    isLoadingServices,
    isLoadingMyVisits,
    allowedServicesError,
    myVisitsData,
    previewVisit,
    setPreviewVisit,
    methods,
  } = useBookingPage();

  if (loading || isLoadingServices || isLoadingMyVisits) {
    return (
      <Container maxWidth="md" sx={{ mt: 8 }}>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/customer-reservations" replace />;
  }

  return (
    <FormProvider {...methods}>
      <Container maxWidth="md" sx={{ mt: 2, mb: 2 }}>
        <Paper elevation={3} sx={{ p: 2 }}>
          <Stack spacing={3}>
            <BookingHeader />
            <LoyaltyPointsBadge />
            <Typography sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
              <FormattedMessage
                id="customerAuth.bookingTitle.helperText"
                defaultMessage="Zde si jako stálý zákazník můžete rezervovat termín po domluvě s kadeřnicí. Termín lze zrušit pouze telefonicky z důvodu přehledu kadeřnice."
              />
            </Typography>
            {myVisitsData && myVisitsData.length > 0 && <MyVisitsList visits={myVisitsData} />}
            {servicesData?.services && servicesData.services.length > 0 ? (
              <>
                <BookingCalendarSection
                  previewVisit={previewVisit}
                  setPreviewVisit={setPreviewVisit}
                />
                <BookingReservationSummary
                  previewVisit={previewVisit}
                  setPreviewVisit={setPreviewVisit}
                />
              </>
            ) : (
              <Alert severity="warning">
                {(allowedServicesError && allowedServicesError.message) || (
                  <FormattedMessage id="customerAuth.noCompletedServices" />
                )}
              </Alert>
            )}
          </Stack>
        </Paper>
      </Container>
    </FormProvider>
  );
};

export default BookingPage;
